var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPizzaCircleWholeDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_88",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cecece"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_84",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cecece"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_Circulo",
    "data-name": "Componente Circulo",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Elipse_88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_88-2",
    "data-name": "Elipse 88",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(9 6)",
    fill: "#3fae7f",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2012",
    "data-name": "Grupo 2012"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Elipse_84)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_84-2",
    "data-name": "Elipse 84",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(9 6)",
    fill: "#3fae7f"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(10.412 15)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "2"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPizzaCircleWholeDouble);
export default __webpack_public_path__ + "static/media/ic_pizza_circle_whole_double.bb972d5b2c3c67b0f63b4fb196352115.svg";
export { ForwardRef as ReactComponent };